"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'accountGrade.form.title.edit': 'Edytuj Pakiet Cenowy',
    'accountGrade.form.title.add': 'Dodaj Pakiet Cenowy',
    'accountGrade.form.back': 'Wstecz',
    'accountGrade.form.name.label': 'Nazwa',
    'accountGrade.form.name.placeholder': 'Nazwa klasy konta',
    'accountGrade.form.description.label': 'Opis',
    'accountGrade.form.description.placeholder': 'Opis klasy konta',
    'accountGrade.form.advancedPrompts.label': 'Zaawansowane Prompty',
    'accountGrade.form.advancedPrompts.description': 'Pozwól użytkownikom na dostęp do zaawansowanych funkcji promptów',
    'accountGrade.form.promptAssist.label': 'Asystent Promptów',
    'accountGrade.form.promptAssist.description': 'Zapewnij pomoc w tworzeniu promptów',
    'accountGrade.form.maxAvatars.label': 'Maks. Awatarów',
    'accountGrade.form.maxAvatars.placeholder': 'Maksymalna liczba awatarów (zostaw puste dla nieograniczonej)',
    'accountGrade.form.maxUsers.label': 'Maks. Użytkowników',
    'accountGrade.form.maxUsers.placeholder': 'Maksymalna liczba użytkowników (zostaw puste dla nieograniczonej)',
    'accountGrade.form.maxProjectsCount.label': 'Maks. Projektów',
    'accountGrade.form.maxProjectsCount.placeholder': 'Maksymalna liczba projektów (zostaw puste dla nieograniczonej)',
    'accountGrade.form.maxKnowledgeEntries.label': 'Maks. Wpisów Wiedzy',
    'accountGrade.form.maxKnowledgeEntries.placeholder': 'Maksymalna liczba wpisów wiedzy (zostaw puste dla nieograniczonej)',
    'accountGrade.form.antiHallucination.label': 'Anti-Halucynacja',
    'accountGrade.form.antiHallucination.description': 'Włącz funkcje anti-halucynacji',
    'accountGrade.form.advancedReports.label': 'Zaawansowane Raporty',
    'accountGrade.form.advancedReports.description': 'Dostęp do zaawansowanych funkcji raportowania',
    'accountGrade.form.chatThreadSharing.label': 'Udostępnianie Wątków Czatu',
    'accountGrade.form.chatThreadSharing.description': 'Pozwól na udostępnianie wątków czatu',
    'accountGrade.form.customBranding.label': 'Własny Branding',
    'accountGrade.form.customBranding.description': 'Włącz opcje własnego brandingu',
    'accountGrade.form.widgets.label': 'Widżety',
    'accountGrade.form.widgets.description': 'Dostęp do funkcjonalności widżetów',
    'accountGrade.form.customAiModels.label': 'Własne Modele AI',
    'accountGrade.form.customAiModels.description': 'Pozwól na konfiguracje własnych modeli AI',
    'accountGrade.form.voiceAgent.label': 'Agent Głosowy',
    'accountGrade.form.voiceAgent.description': 'Włącz funkcjonalność agenta głosowego',
    'accountGrade.form.writingStyles.label': 'Style Pisania',
    'accountGrade.form.writingStyles.description': 'Dostęp do funkcji stylów pisania',
    'accountGrade.form.save': 'Zapisz Pakiet Cenowy',
    'accountGrade.form.saving': 'Zapisywanie...',
    'accountGrade.form.unlimited': 'Nieograniczone',
    'accountGrade.form.price.label': 'Cena Miesięczna',
    'accountGrade.form.price.placeholder': 'Cena miesięczna (w USD)',
    'accountGrade.form.price.monthly.help': 'Cena subskrypcji miesięcznej w USD',
    'accountGrade.form.yearlyPrice.placeholder': 'Cena roczna (w USD)',
    'accountGrade.form.yearlyPrice.help': 'Cena subskrypcji rocznej w USD (zwykle ze zniżką)',
    'accountGrade.form.creditsPerMonth.placeholder': 'Liczba kredytów przyznawanych miesięcznie',
    'accountGrade.form.creditsPerMonth.help': 'Kredyty są automatycznie dodawane do kont użytkowników co miesiąc',
    'accountGrade.form.active.label': 'Aktywne',
    'accountGrade.form.active.description': 'Udostępnij tę klasę konta',
    'accountGrade.form.order.label': 'Kolejność',
    'accountGrade.form.order.placeholder': 'Kolejność wyświetlania (opcjonalne)',
    'accountGrade.form.submit.create': 'Utwórz Pakiet Cenowy',
    'accountGrade.form.submit.update': 'Aktualizuj Pakiet Cenowy',
};
